<template>
    <div class="informasi-terbaru">
       <div class="row">
          <div class="col-12">
             <h5 class="title-informasi-terbaru" @mouseover="accebility('informasi terbaru')" v-bind:style="informasiterbaruAccebility(isAccebility)"><img class="image-title" v-bind:src="require('@/assets/icon/icon-title.png')" />INFORMASI TERBARU</h5>
          </div>
          <div v-bind:class="columnStyle.columnRow+ ' slider'">
             <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner">
                   <div class="carousel-item active" v-for="items in data.banner" :key="items" @mouseover="accebility(items.title)">
                      <img v-bind:src="imagesBanner(items)" class="d-block w-100 image-slide" />
                      <div class="carousel-caption">
                        <div class="row">
                            <div class="col-12">
                                <a :href="lihatUrl(items)" :title="items.title">
                                    <h5 class="title-slider-item">{{ limitTitle(items.title, 50) }}</h5>                                    
                                </a>
                                <p class="desc-slider-item">{{ limitTitle(items.title, 120) }}</p>
                            </div> 
                            <div class="col-5">
                                <p class="tanggal-slider-item">{{ toDate(items.created_at) }}</p>
                            </div>
                            <div class="col-7" align="right">
                                <a :href="lihatUrl(items)"><button class="button-lihat">Baca Selengkapnya</button></a>                                
                            </div>
                            <div class="col-1"></div>
                        </div>
                      </div>
                   </div>
                </div>
                <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span> <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span> <span class="visually-hidden">Next</span>
                </button>
             </div>
          </div>
          <div v-bind:class="columnStyle.columnRow+ ' item'">
             <div class="row">
                <div v-bind:class="columnStyle.columnItems" v-for="item in data.items" :key="item">
                   <a  :href="lihatUrl(item)" class="card cards-hover" :title="item.title" @mouseover="accebility(item.title)">
                      <img v-bind:src="imagesItem(item)" class="card-img-top"  v-bind:style="imgPositions(item.category)"/>
                      <div class="card-body">
                         <span class="tag-page">{{ substringDash(item.page) }}</span>
                         <span class="tag-category">{{ substringDash(item.category) }}</span>
                         <h5 class="card-title">
                            <!-- {{ item.title.length}} -->
                            {{ limitTitle(item.title, 65) }}</h5>
                      </div>
                    </a>
                </div>
             </div>
          </div>
       </div>
    </div>
 </template>
 <script>
    import axios from "axios";
    export default {
        name: "InformasiterbaruComponents",
        components: {},
        data() {
            return {
                baseUrl:this.$store.state.baseUrl,
                baseApi:this.$store.state.apiUrl,
                data: [],
                columnStyle: [],
                windowWidth: window.innerWidth,
                isAccebility:this.$store.state.isAccebility
            };
        },
        mounted() {
        
            axios.get(`${this.baseApi}/api/v2/satudata/informasi-terbaru`).then((res) => {
                this.data = res.data;
            });
            this.$nextTick(() => {
                window.addEventListener("resize", this.onResize);
            });
            
            if (this.windowWidth <= "430") {
                this.columnStyle = {
                    columnRow: "col-12",
                    columnItems: "col-12",
                };
            } else if(this.windowWidth > "430" && this.windowWidth <= "820") {
                this.columnStyle = {
                    columnRow: "col-12",
                    columnItems: "col-4",
                };
            } else {
                this.columnStyle = {
                    columnRow: "col-6",
                    columnItems: "col-4",
                }; 
            }
        },
        methods: {
            imagesBanner(items){
                return this.baseApi+'/uploads/img/700/'+items.path_cover
            },
            informasiterbaruAccebility(isAccebility){
                if(isAccebility.modeMalam){
                    return{
                        color: 'white'
                    }
                } else {
                    return{
                        color: '#052158'
                    }
                }
            },
            imagesItem(items){
                if(items.category == 'dataset'){
                    if(items.topik_uid == null || items.topik_uid==''){
                        return this.baseApi+items.path_cover
                    }else{
                        //return this.baseApi+'/uploads/img/topik/'+items.topik_uid.split(',')[0]+'.jpg'
                        return this.baseApi+'/uploads/img/topik/'+items.topik_image
                    } 
                } else {
                    return this.baseApi+'/uploads/img/300/'+items.path_cover
                }
            },
            imgPositions(category){
                if(category == 'dataset'){
                    return 'object-position: 0px -54px'
                } else {
                    return 'object-position: 0px'
                }
            },
            // toDate(items) {
            //     let date = new Date(items);
            //     let month = date.getMonth() + 1;
            //     return date.getFullYear() + "-" + month + "-" + date.getDay();
            // },
            /*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
            toDate(items){
            let dates = new Date(items)
            //let month = ("0" + (dates.getMonth() + 1)).slice(-2)
            let month = dates.toLocaleString("id-ID",{month:"long"})
            let date = ("0" + (dates.getDay() + 1)).slice(-2)
            return date+' '+month+' '+dates.getFullYear()
            //   return date+'-'+month+'-'+dates.getFullYear()
            },
            substringDash(string){
                return string.replace('-', ' ')
            },
            limitTitle(string = "", limit = 0) {
                if (string) {
                    let next = "";
                    if (string.length > limit) {
                        next = " ...";
                    }
                    return string.substring(0, limit) + next;
                }
            },
            lihat(items) {
                switch (items.category) {
                    case "topik":
                        window.location.href = "topik?topik_uid=" + items.topik_uid + "&page_no=1&show_filter=true&lang=id";
                        break;
                    case "organisasi":
                        window.location.href = "organisasi?org_uid=" + items.org_uid + "&page_no=1&show_filter=true&lang=id";
                        break;
                    case "dataset":
                        window.location.href = "/open-data/detail?kategori=dataset&page_url=" + items.page_url+"&data_no=1";
                        break;
                    case "artikel":
                        window.location.href = "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                        break;
                    case "infografis":
                        window.location.href = "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                        break;
                    case "analisis":
                        window.location.href = "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                        break;
                    case "hasil-survei":
                        window.location.href = "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                        break;
                    case "produk-statistik":
                        window.location.href = "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                        break;
                }
            },
            lihatUrl(items) {
                switch (items.category) {
                    case "topik":
                        return this.baseUrl + "topik?topik_uid=" + items.topik_uid + "&page_no=1&show_filter=true&lang=id";
                    case "organisasi":
                         return this.baseUrl + "organisasi?org_uid=" + items.org_uid + "&page_no=1&show_filter=true&lang=id";
                    case "dataset":
                         return this.baseUrl + "/open-data/detail?kategori=dataset&page_url=" + items.page_url+"&data_no=1";
                    case "artikel":
                         return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                    case "infografis":
                         return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                    case "analisis":
                         return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                    case "hasil-survei":
                         return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                    case "produk-statistik":
                         return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
                }
            },
            onResize() {
                this.windowWidth = window.innerWidth;
            },
            accebility(voice){
                if(this.isAccebility.modeSuara){
                let msg = new SpeechSynthesisUtterance();
                let voices = window.speechSynthesis.getVoices()
                msg.voice = voices[160];
                msg.text = voice;
                msg.volume = 10;
                msg.rate = 1;
                msg.pitch = 1;
                window.speechSynthesis.cancel();
                window.speechSynthesis.speak(msg);
                }
            },
            eventChngescreen(e) {
            this.windowWidth = e.currentTarget.screen.availWidth
            if (this.windowWidth <= "430") {
                this.columnStyle = {
                    columnRow: "col-12",
                    columnItems: "col-6",
                };
            } else if(this.windowWidth > "430" && this.windowWidth <= "820") {
                this.columnStyle = {
                    columnRow: "col-12",
                    columnItems: "col-4",
                };
            } else {
                this.columnStyle = {
                    columnRow: "col-6",
                    columnItems: "col-4",
                }; 
            }
            }
        },
        created() {
            window.addEventListener("resize", this.eventChngescreen);
        },
        beforeUnmount() {
            window.removeEventListener("resize", this.eventChngescreen);
        }
    };
 </script>